<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      class="tw-w-full"
      :label="meta.filter.quickFilter ? '' : $t('Contains items with status')"
      :list="statuses"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 10"
      :placeholder="$t('All statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { BatchItemStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const statusLabels: Record<string, string> = {
  [BatchItemStatus.Processing]: $t('Processing'),
  [BatchItemStatus.Processed]: $t('Processed'),
}

const orderedStatuses = [
  BatchItemStatus.Processing,
  BatchItemStatus.Processed,
]

const statuses = computed(() =>
  orderedStatuses.map((value) => ({
    label: statusLabels[value] ?? value,
    value,
  })),
)
</script>
